










import {Component, Prop, Vue} from "vue-property-decorator"

@Component({})
export default class LoadingSpinner extends Vue {
  @Prop({
    default: () => {
      return {w: '100%', h: '100%'}
    },
  }) public size!: { w: string, h: string }
  @Prop({default: "default"}) public spinner!: string
}
